import { apiGet } from '../../api'

export const get_diligence = query => {
  return apiGet({
    endpoint: `recruitment/get_diligence?${query}`
  })
}
